import { ZfDialogFooter, ZfDrawer, ZfDrawerContent, ZfDrawerHeader, ZfStack, ZfTextButton } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NAVIGATION_BAR_HEIGHT, PANEL_PADDING, PRIMARY_NAVIGATION_BAR_HEIGHT, SESSIONS_PANEL_WIDTH } from '../../config/constants';
import { useLayout } from '../../contexts/layout-context';
import { useYwuApp } from '../../contexts/ywu-app-context';
import { useShadowRootCustomStyles } from '../../hooks/useShadowRootCustomStyles';
import type { ISessionFilter } from '../../interfaces/client';
import { SessionFilter } from './SessionFilter';

interface IProps {
    isOpen: boolean;
    filters: ISessionFilter;
    availableCountryCodes: string[];
    onSetFilter: (filter: ISessionFilter) => void;
    onClose: () => void;
}

export const SessionDrawer: FunctionComponent<IProps> = ({ isOpen, filters, availableCountryCodes, onSetFilter, onClose }) => {
    const { t } = useTranslation();
    const { totalNavbarHeight } = useLayout();
    const { isWealthNavigatorMFE } = useYwuApp();

    const drawerRef = useRef<HTMLZfDrawerElement>(null);
    const [sessionFilters, setSessionFilters] = useState<ISessionFilter>(filters);

    useEffect(() => setSessionFilters(filters), [filters]);

    useShadowRootCustomStyles(
        drawerRef,
        `dialog.drawer { margin-top: ${isWealthNavigatorMFE ? PRIMARY_NAVIGATION_BAR_HEIGHT : NAVIGATION_BAR_HEIGHT}px !important; height: calc(100vh - ${totalNavbarHeight}px) !important; }`,
    );

    const onApplyFilter = () => {
        onSetFilter(sessionFilters);
        onClose();
    };

    const handleReset = () => {
        onSetFilter({});
        onClose();
    };

    return (
        <ZfDrawer anchor="parent" side="left" show={isOpen} className="session-drawer" onDrawerClose={onClose} ref={drawerRef}>
            <ZfDrawerHeader>{t('sessionFilter')}</ZfDrawerHeader>
            <ZfDrawerContent>
                <div style={{ minWidth: isOpen ? `${SESSIONS_PANEL_WIDTH - PANEL_PADDING * 2}px` : 0 }}>
                    <SessionFilter filters={sessionFilters} availableCountryCodes={availableCountryCodes} onFilterChange={setSessionFilters} />
                </div>
            </ZfDrawerContent>
            <ZfDialogFooter>
                <ZfStack slot="primary" direction="row" spacing="extra-small">
                    <ZfTextButton size="medium" hierarchy="tertiary" onClick={handleReset}>
                        {t('sessionFilterReset')}
                    </ZfTextButton>
                    <ZfTextButton size="medium" hierarchy="primary" onClick={onApplyFilter}>
                        {t('viewResult')}
                    </ZfTextButton>
                </ZfStack>
            </ZfDialogFooter>
        </ZfDrawer>
    );
};
